import { Constants } from '../_constants/constants';
import { BaseParameterDto } from './base-parameter-dto';

export class LoginParameterDto extends BaseParameterDto {
    username: string;
    password: string;
    recaptchaToken: string;
    portalType = Constants.portalType;
}
